<template>
  <MainLayout>
    <b-row id="Logs">
      <b-col
        class="shadow-sm"
        style
      >
        <h4 class="card-title font-weight-bold">
          {{ scope }} Logs
        </h4>

        <b-card-body>
          <b-row>
            <ErrorLog
              :scope="scope"
              class="w-100"
            />
          </b-row>
        </b-card-body>
      </b-col>
    </b-row>
    <div style="height: 500px" />
  </MainLayout>
</template>

<script>
import MainLayout from "@/layouts/MainLayout.vue";
import ErrorLog from "@/components/logs/ErrorLog.vue";

export default {
  components: {
    MainLayout,
    ErrorLog,
  },
  data() {
    return {
      scope: "",
    };
  },
  watch: {
    "$route.params.scope"(newValue) {
      this.scope = this.checkscope(newValue);
    },
  },
  created() {
    this.scope = this.checkscope(this.$route.params.scope);
  },

  methods: {
    checkscope(scope) {
      switch (scope) {
        case "tempdataapi":
          return "TEMPDATA ";
        case "secoapi":
          return "SECO ";
        case "admin":
          return "ADMIN ";
        case "gavservice":
          return "GAV-SERVICE ";
        default:
          return "undifined ";
      }
    },
  },
};
</script>

<style scoped>
#stichwortSelector .v-list__tile--link {
  padding: 9px;
}

#stichwortSelector .v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}

.keyWordPropertyListItem {
  list-style-position: inside;
}

.viewModeValue {
  font-size: initial;
}

.searchSelectList {
  height: 600px;
}

.loadingGif {
  height: 200px;
  width: 200px;
  position: relative;
  left: 25%;
}

.mutliselectSelectionItem {
  padding: 4px 11px;
  background-color: rgb(0, 140, 255);
  color: white;
  border-radius: 5px;
}

.mutliselectSelectionItem i {
  margin-left: 5px;
  font-size: 14px;
}

.anchorForMultiselect {
  width: 100%;
  height: 1px;
  position: relative;
  top: 0px;
}
</style>
